import api from 'api/apiClient';
import { formatAmount, formatDate } from 'modules/shared/utils';
import { PROJECT_VIEW_MAP } from 'modules/work-implementation/constants';

const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};

export async function getAnalystProjects() {
  const { data: raw } = await unwrap(await api.get('/api/analyst/jobs'));

  const normalized = {
    not_started: [],
    assigned: [],
    in_progress: [],
    on_hold: [],
    completed: [],
    cancelled: [],
  };

  raw.forEach((project) => {
    const status = PROJECT_VIEW_MAP[project.job_status];
    if (!status) return;

    normalized[status].push({
      id: project.id,
      code: project.job_code,
      name: project.job_name,
      date: formatDate(project.job_date),
      status: status,
      client: project.client_name,
      value: formatAmount(project.job_value),
      totalMilestones: project.milestone_count,
      completedMilestones: project.milestones_completed,
    });
  });

  return normalized;
}
